import React, { useEffect, useState } from "react";

import { getDiffDays } from "../../../shared/utils/dateUtilities";
import { likeComment } from "../../../services/tribe";
import CommentInput from "../../molecules/comment-input/commentInput";
import CommentResponse from "./commentResponse";

import "./cardComment.scss";

interface CardCommentProps {
  summary: string;
  counts: any;
  createdAt: string;
  id: string;
  upvotes: Array<any>;
  user: {
    id: string;
    profile: any;
  };
  responses: Array<any>;
  images: Array<any>;
  videos: Array<any>;
  userId: string;
  userInfo: any;
  handleSelection?: Function;
  showComments?: boolean;
  showInput?: boolean;
  handleNewCommentModal: Function;
  editingCommentHandler?: any;
  handleEditing: any;
  gigyaAccount: any;
  setReplyCommentId: any;
}

const MONTHS = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre",
];

const CardComment = (props: CardCommentProps) => {
  const { showComments = false, showInput = false } = props;

  const [likeAvailable, setLikeAvailable] = useState(true);
  const [totalLikes, setTotalLikes] = useState(0);
  const [showModalDelete, setShowModalDelete] = useState(false);

  useEffect(() => {
    if (props.upvotes !== undefined) {
      setLikeAvailable(!props.upvotes.find((vote) => vote.id === props.userId));
    }
    if (props.counts.upvotes !== undefined) {
      setTotalLikes(props.counts.upvotes);
    }
  }, [props.id]);

  const formatDate = (date: string) => {
    const today = new Date();
    const cd = date
      .split(" ")[0]
      .split("/")
      .map((cd) => parseInt(cd));
    const ct = date
      .split(" ")[1]
      .split(":")
      .map((ct) => parseInt(ct));
    const commentDate = new Date(cd[2], cd[1] - 1, cd[0], ct[0], ct[1], ct[1]);
    const daysDiff = getDiffDays(commentDate.toString(), today.toString());
    const hoursDiff = today.getHours() - commentDate.getHours();
    const minutesDiff = today.getMinutes() - commentDate.getMinutes();
    if (daysDiff > 7) {
      return cd[0] + " " + MONTHS[cd[1] - 1] + " " + cd[2];
    } else if (daysDiff > 0) {
      return daysDiff > 1 ? "Hace " + daysDiff + " días" : "Ayer";
    } else if (hoursDiff > 0) {
      return "Hace " + hoursDiff + (hoursDiff > 1 ? " horas" : " hora");
    } else if (minutesDiff > 0) {
      return "Hace " + minutesDiff + (minutesDiff > 1 ? " minutos" : " minuto");
    } else {
      return "Hace menos de 1 minuto";
    }
  };

  const getClassByCharsQuant = (text: string) => {
    const charsQuant = text.length;
    if (charsQuant <= 100) {
      return "a-card-comment__text--short";
    } else if (charsQuant <= 200) {
      return "a-card-comment__text--medium";
    } else {
      return "a-card-comment__text--large";
    }
  };

  const likeAction = () => {
    likeComment(
      likeAvailable ? "LIKE" : "DISLIKE",
      props.id,
      props.userInfo.email
    );
    setLikeAvailable(!likeAvailable);
    setTotalLikes(likeAvailable ? totalLikes + 1 : totalLikes - 1);
  };

  const adjustYTUrl = (url: string) =>
    url.replace("watch?v=", "embed/").slice(0, url.indexOf("&") - 2);

  const deleteHandler = async (idComment) => {
    const URL = process.env.URL_BIBLIOTECAS_SERVICES;
    const optionUser = confirm("¿Seguro desea eliminar el comentario?");

    if (optionUser === true) {
      const req = await fetch(
        `${URL}/community/api/v1/response?responseId=${idComment}&email=${props.gigyaAccount.profile.email}`,
        {
          method: "DELETE",
        }
      );
      await req.json();
      window.location.reload();
    }
  };

  const handleNewComment = () => {
    props.handleNewCommentModal(true);
    props.setReplyCommentId(props.id);
  };

  return (
    <div
      className="a-card-comment"
      onClick={() => {
        if (showModalDelete) document.getElementById("modal-delete")?.click();
      }}
    >
      <div
        className={`a-card-comment__header ${
          props.handleSelection ? "a-card-comment__header--click" : ""
        }`}
        onClick={() =>
          props.handleSelection ? props.handleSelection(props.id) : false
        }
      >
        <img
          className="a-card-comment__header__photo"
          src={props.user.profile.picture}
          alt={`Foto ${props.user.profile.name}`}
        />
        <div className="a-card-comment__header__texts">
          <p className="a-card-comment__header__texts__name">
            {props.user.profile.name}
          </p>
          <p className="a-card-comment__header__texts__date">
            {formatDate(props.createdAt)}
          </p>
        </div>
      </div>
      <p
        className={`a-card-comment__text ${getClassByCharsQuant(
          props.summary
        )} ${props.handleSelection ? "a-card-comment__text--click" : ""} ${
          props.images[0] || props.videos[0]
            ? "a-card-comment__text--no-margin"
            : ""
        }
        `}
        onClick={() =>
          props.handleSelection ? props.handleSelection(props.id) : false
        }
      >
        {props.summary.slice(0, 300)}
      </p>
      {props.images[0] && (
        <img
          className="a-card-comment__image"
          src={props.images[0].src}
          alt={`Comentario ${props.user.profile.name} ${props.createdAt}`}
        />
      )}
      {props.videos[0] && !props.images[0] && (
        <iframe
          className="a-card-comment__video"
          width="640"
          height="360"
          src={adjustYTUrl(props.videos[0].original)}
        />
      )}
      <div className="a-card-comment__divider"></div>
      <div className="a-card-comment__likes-section">
        <div
          className="a-card-comment__likes-section__likes"
          onClick={() => setShowModalDelete(false)}
        >
          <p
            className={`a-card-comment__likes-section__likes__action ${
              props.userInfo.email && props.userId !== props.user.id
                ? ""
                : "a-card-comment__likes-section__likes__action--disabled"
            } ${
              likeAvailable
                ? ""
                : "a-card-comment__likes-section__likes__action--liked"
            }`}
            onClick={props.userInfo.email && props.userId !== props.user.id 
              ? 
              () => likeAction() 
              : () => false
            }
          >
            <i
              className={`a-card-comment__likes-section__likes__action ${
                likeAvailable || !props.userInfo.email
                  ? "icon-thumbs-up"
                  : "icon-thumbs-up1"
              }`}
            />
            Me gusta
          </p>
          <div className="a-card-comment__vertical-divider"></div>
          <p
            className={`a-card-comment__likes-section__likes__total-likes ${
              likeAvailable
                ? ""
                : "a-card-comment__likes-section__likes__total-likes--liked"
            }`}
          >
            {totalLikes}
          </p>
        </div>
        {props.userId === props.user.id &&
          props.userId !== "5fbfacc3dbf3e04c82adedd8" && (
            <div className="a-card-comment__likes-section__edit">
              <p
                className="a-card-comment__likes-section__edit-edit icon-edit"
                onClick={() => {
                  props.handleNewCommentModal(true);
                  props.editingCommentHandler(
                    props.summary.slice(0, 300),
                    props.id
                  );
                }}
              ></p>
              <p
                className="a-card-comment__likes-section__edit-delete icon-trash-alt"
                id="modal-delete"
                onClick={() => {
                  deleteHandler(props.id);
                }}
              ></p>
            </div>
          )}
        <p
          className="a-card-comment__likes-section__comments"
          onClick={() =>
            props.handleSelection ? props.handleSelection(props.id) : false
          }
        >
          {props.responses.length}{" "} {props.responses.length === 1 ? "comentario" : "comentarios"}
        </p>
      </div>
      {showComments && props.responses.length > 0 && (
        <>
          <div className="a-card-comment__divider a-card-comment__divider-comments"></div>
          <div className="a-card-comment__comments-container">
            {props.responses.slice(0, 2).map((response, idx) => (
              <CommentResponse
                key={idx}
                {...response}
                userInfo={props.userInfo}
                userId={props.userId}
                setShowModalDelete={setShowModalDelete}
                handleNewCommentModal={props.handleNewCommentModal}
                deleteHandler={deleteHandler}
                showModalDelete={showModalDelete}
                editingCommentHandler={props.editingCommentHandler}
              />
            ))}
          </div>
          {props.responses.length > 2 && (
            <div className="a-card-comment__see-more">
              <p
                className="a-card-comment__see-more__text"
                onClick={() =>
                  props.handleSelection
                    ? props.handleSelection(props.id)
                    : false
                }
              >
                Ver más respuestas
              </p>
            </div>
          )}
        </>
      )}
      {props.gigyaAccount && showInput && (
        <div
          className="a-card-comment__new-comment"
          onClick={() =>
            props.handleNewCommentModal ? handleNewComment() : false
          }
        >
          <CommentInput
            gigyaAccount={props.gigyaAccount}
            discussionId={props.id}
          />
        </div>
      )}
    </div>
  );
};

export default CardComment;
